var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "42.55px",
    height: "50px",
    viewBox: "0 0 42.55 50",
    style: {
      enableBackground: "new 0 0 42.55 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.19,43.28h-1.88c-0.28-9.08-5.73-16.57-12.9-18.29c7.17-1.72,12.62-9.2,12.9-18.29h1.88 c1.86,0,3.36-1.5,3.36-3.36s-1.5-3.36-3.36-3.36H3.36C1.5-0.01,0,1.49,0,3.35S1.5,6.7,3.36,6.7h1.88 c0.28,9.08,5.73,16.57,12.9,18.29c-7.17,1.72-12.62,9.2-12.9,18.29H3.36C1.5,43.28,0,44.78,0,46.64S1.5,50,3.36,50h35.83 c1.86,0,3.36-1.5,3.36-3.36S41.05,43.28,39.19,43.28z M11.94,12.63h18.66c0,4.99-4.18,9.05-9.33,9.05S11.94,17.63,11.94,12.63z  M9.83,43.28L20.9,30.59l11.82,12.69H9.83z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "hourglass.0828e0027402bf57b95549ebac3efdf8.svg";
export { ForwardRef as ReactComponent };